import { logger } from '@loc/helpers/src/logger/client'

import type { CacheWithData, PromotionCoreConfig } from '../core'

export function initialBannerConfig(data: PromotionCoreConfig) {
  return { open: false, ...data }
}

export type LocalCacheData = CacheWithData & {
  stat: {
    /** 已关闭次数 */
    closedCount: number
    /** 缓存更新时间，使用 unix 时间戳 */
    unixTimestamp: number
    /**
     * 是否已终止，如果已终止则不再弹出,
     * 该字段用于特殊场景，比如用户点击了特定按钮后不再弹出
     */
    terminated?: boolean
  }
}

export interface KeyOptions {
  keyPrefix: string
  keySuffix?: string
}

export function getCacheKey(key: string, keyOptions: KeyOptions) {
  const { keyPrefix, keySuffix } = keyOptions
  const prefixedKey = `${keyPrefix}_${key}`

  return keySuffix ? `${prefixedKey}_${keySuffix}` : prefixedKey
}

export interface SetLocalCacheDataOptions {
  key: string
  keyOptions: KeyOptions
  data: LocalCacheData
}

export function setLocalCacheData(options: SetLocalCacheDataOptions) {
  const { key, keyOptions, data } = options
  localStorage.setItem(getCacheKey(key, keyOptions), JSON.stringify(data))
}

export function removeLocalCacheData(key: string, keyOptions: KeyOptions) {
  localStorage.removeItem(getCacheKey(key, keyOptions))
}

export function getLocalCacheData(
  key: string,
  keyOptions: KeyOptions,
): LocalCacheData | null {
  const data = localStorage.getItem(getCacheKey(key, keyOptions))
  if (!data) {
    return null
  }
  try {
    return JSON.parse(data)
  } catch (error) {
    logger.log(error)
    return null
  }
}
